import { api } from "@/lib/apiClient";

export type ListUnitsParams = {
  q?: string;
  limit?: number;
  offset?: number;
};

export type UnitListItem = {
  id: string;
  tenant_id: string;
  person_id: string;
  name: string;
  legal_name?: string | null;
  document_number?: string | null;
  tenant_name?: string | null;
  tenant_document_number?: string | null;
  employee_count: number;
  is_active: boolean;
  created_at?: string | null;
  updated_at?: string | null;
};

export type UnitDetailOut = {
  unit: {
    id: string;
    tenant_id: string;
    person_id: string;
    is_active: boolean;
    created_at?: string | null;
    updated_at?: string | null;
  };
  tenant: {
    tenant_id: string;
    tenant_slug: string;
    tenant_name: string;
    tenant_document_number?: string | null;
  };
  person: {
    id: string;
    person_type: "PF" | "PJ";
    name: string;
    legal_name?: string | null;
    document_number?: string | null;
    photo?: {
      base64: string;
      mime_type: string;
    } | null;
    photo_file_name?: string | null;
    photo_size_bytes?: number | null;
    is_active: boolean;
    created_at?: string | null;
    updated_at?: string | null;
  };
  contacts: Array<{
    id: string;
    kind: "email" | "phone" | "whatsapp" | "other";
    value: string;
    is_primary: boolean;
    created_at?: string;
  }>;
  addresses: Array<{
    id: string;
    label?: string | null;
    zip?: string | null;
    street?: string | null;
    number?: string | null;
    complement?: string | null;
    district?: string | null;
    city?: string | null;
    state?: string | null;
    country?: string | null;
    is_primary: boolean;
    created_at?: string;
  }>;
  users: Array<{
    id: string;
    person_id: string;
    name: string;
    email: string;
    is_active: boolean;
    unit_id?: string | null;
  }>;
};

export type UnitUpsertIn = {
  person: {
    person_type: "PJ";
    name: string;
    legal_name?: string | null;
    document_number?: string | null;
    photo?: {
      photo_base64?: string | null;
      photo_mime_type?: string | null;
      photo_file_name?: string | null;
    } | null;
    contacts: Array<{
      kind: "email" | "phone" | "whatsapp" | "other";
      value: string;
      is_primary: boolean;
    }>;
    addresses: Array<{
      label?: string | null;
      zip?: string | null;
      street?: string | null;
      number?: string | null;
      complement?: string | null;
      district?: string | null;
      city?: string | null;
      state?: string | null;
      country?: string | null;
      is_primary: boolean;
    }>;
  };
  is_active: boolean;
  assigned_user_ids: string[];
};

export async function listUnits(params: ListUnitsParams = {}) {
  const { q = "", limit = 50, offset = 0 } = params;

  return api.get<UnitListItem[]>("/units", {
    params: { q, limit, offset },
  });
}

export async function getUnitDetail(unitId: string) {
  return api.get<UnitDetailOut>(`/units/${unitId}`);
}

export async function createUnit(payload: UnitUpsertIn) {
  return api.post<{ id: string }>("/units", payload);
}

export async function updateUnit(unitId: string, payload: UnitUpsertIn) {
  return api.put<{ id: string }>(`/units/${unitId}`, payload);
}

export async function setUnitActive(unitId: string, is_active: boolean) {
  return api.patch<{ id: string }>(`/units/${unitId}`, { is_active });
}
